import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-02059a00")

_pushScopeId("data-v-02059a00")
const _hoisted_1 = { style: {"white-space":"nowrap"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" (")
const _hoisted_3 = /*#__PURE__*/_createVNode("label", { style: {"color":"#8a8a8a"} }, "非厦门号码请在前面加0，比如 013899998888", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(") ")
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = {
  key: 0,
  style: {"color":"#FF7209"}
}
const _hoisted_7 = {
  key: 1,
  style: {"color":"#FF7209"}
}
const _hoisted_8 = {
  key: 2,
  style: {"color":"#FF7209"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_question_tip = _resolveComponent("question-tip")
  const _component_relay = _resolveComponent("relay")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock(_component_dialog_shell, {
    title: _ctx.titles[_ctx.operaType],
    footerType: "customize",
    onClose: _cache[24] || (_cache[24] = ($event: any) => (_ctx.$emit('close'))),
    onSubmit: _ctx.submit
  }, {
    footer: _withId(() => [
      _createVNode(_component_el_row, { class: "width100per" }, {
        default: _withId(() => [
          _createVNode(_component_el_col, {
            span: 6,
            class: "justify-start"
          }, {
            default: _withId(() => [
              (_ctx.operaType === 'edit')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "danger",
                    onClick: _ctx.resetRoom
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.$wordList.Reset), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 18,
            class: "justify-end"
          }, {
            default: _withId(() => [
              (_ctx.operaType == 'edit')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    onClick: _ctx.resetPw,
                    disabled: _ctx.initForm.Email === '' || _ctx.initForm.Email === null,
                    type: "primary"
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.$wordList.TabelResetPwTitle), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_button, {
                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.$emit('close')))
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootCancel), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.checkValid
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootSubmit), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withId(() => [
      _createVNode(_component_el_form, {
        ref: "formRef",
        "label-position": _ctx.$formLabelPosition,
        model: _ctx.formData,
        rules: _ctx.rules
      }, {
        default: _withId(() => [
          (_ctx.operaType === 'edit')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: _ctx.$wordList.TabelPersonUserInHtmlUID
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.SipGroup,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.SipGroup = $event)),
                    disabled: true
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.TabelPersonUserInHtmlName,
            prop: "Name"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.Name,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.Name = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.TabelPersonUserInHtmlRoomName
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.RoomNumber,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.RoomNumber = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.TabelPropertyManageEmail,
            prop: "Email"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.Email,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.Email = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextCountryRegion
          }, {
            default: _withId(() => [
              _createVNode(_component_cus_select, {
                modelValue: _ctx.formData.PhoneCode,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.PhoneCode = $event)),
                filter: "",
                disabled: _ctx.isCNServer ? true : false
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getPhoneCodeOps(), (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item,
                      value: item.value,
                      label: item.label
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextMobileNumber,
            prop: "MobileNumber"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.MobileNumber,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.MobileNumber = $event)),
                onInput: _ctx.limitMobileNumberType
              }, null, 8, ["modelValue", "onInput"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.TabelCommunitiesAddress,
            prop: "Address"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.Address,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.Address = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextSipIpCall,
            prop: "EnableIpDirect"
          }, {
            default: _withId(() => [
              _createVNode(_component_cus_select, {
                modelValue: _ctx.formData.EnableIpDirect,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formData.EnableIpDirect = $event))
              }, {
                default: _withId(() => [
                  _createVNode(_component_cus_option, {
                    label: _ctx.$wordList.ProperAllTextSIPCall,
                    value: 0
                  }, null, 8, ["label"]),
                  _createVNode(_component_cus_option, {
                    label: _ctx.$wordList.ProperAllTextIPCall,
                    value: 1
                  }, null, 8, ["label"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.TabelCommunitiesTimeZone
          }, {
            default: _withId(() => [
              _createVNode(_component_cus_select, {
                modelValue: _ctx.formData.TimeZone,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formData.TimeZone = $event)),
                filter: ""
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.timeZoneOptions, (tiemZoneItem) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: tiemZoneItem,
                      label: tiemZoneItem.label,
                      value: tiemZoneItem.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.operaType === 'add')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                label: _ctx.$wordList.ProperAllTextLanguage
              }, {
                default: _withId(() => [
                  _createVNode(_component_cus_select, {
                    modelValue: _ctx.formData.Language,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formData.Language = $event))
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.langOptions, (langItem) => {
                        return (_openBlock(), _createBlock(_component_cus_option, {
                          key: langItem,
                          label: langItem.label,
                          value: langItem.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextFirstPhone
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.Phone,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formData.Phone = $event))
              }, null, 8, ["modelValue"]),
              _createVNode("label", _hoisted_1, [
                (_ctx.isCNServer)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_2,
                      _hoisted_3,
                      _hoisted_4
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextSecondPhone
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.Phone2,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.formData.Phone2 = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextThirdPhone
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.Phone3,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.formData.Phone3 = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.sysConfig.EnableSmartHome)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 2,
                label: _ctx.$wordList.HomeAutoMation
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_radio, {
                    modelValue: _ctx.formData.EnableSmartHome,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.formData.EnableSmartHome = $event)),
                    label: "1",
                    disabled: _ctx.smartHomeDisabled
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOn), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"]),
                  _createVNode(_component_el_radio, {
                    modelValue: _ctx.formData.EnableSmartHome,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.formData.EnableSmartHome = $event)),
                    label: "0",
                    disabled: _ctx.smartHomeDisabled
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOff), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"]),
                  _hoisted_5,
                  (_ctx.formData.EnableSmartHome.toString() === '1')
                    ? (_openBlock(), _createBlock("label", _hoisted_6, _toDisplayString(_ctx.$wordList.HomeAutomationServiceNotice), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.PremiumPlan,
            prop: "PremiumPlan"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.formData.IsPremiumPlanStatus,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.formData.IsPremiumPlanStatus = $event)),
                onChange: _ctx.changePremiumPlan
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_radio, {
                    label: "1",
                    disabled: _ctx.isDisPremiumPlan
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOn), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_el_radio, {
                    label: "0",
                    disabled: _ctx.isDisPremiumPlan
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOff), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"]),
              (_ctx.formData.IsPremiumPlanStatus ==='1')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    label: _ctx.$wordList.ProperAllTextLandlineService,
                    prop: "PhoneStatus"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_radio, {
                        label: "1",
                        modelValue: _ctx.formData.PhoneStatus,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.formData.PhoneStatus = $event)),
                        disabled: _ctx.isDisPremiumPlan
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOn), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"]),
                      _createVNode(_component_el_radio, {
                        label: "0",
                        modelValue: _ctx.formData.PhoneStatus,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.formData.PhoneStatus = $event)),
                        disabled: _ctx.isDisPremiumPlan
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOff), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"]))
                : _createCommentVNode("", true),
              (_ctx.formData.IsPremiumPlanStatus==='1')
                ? (_openBlock(), _createBlock("div", _hoisted_7, _toDisplayString(_ctx.$wordList.PremiumPlanNoticeOn), 1))
                : _createCommentVNode("", true),
              (_ctx.formData.IsPremiumPlanStatus==='0')
                ? (_openBlock(), _createBlock("div", _hoisted_8, _toDisplayString(_ctx.$wordList.PremiumPlanNoticeOff), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.showIndoorMonitor)
            ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                _createVNode("label", null, _toDisplayString(_ctx.$wordList.ProperAllTextIndoorMonitor), 1),
                _createVNode(_component_question_tip, {
                  placement: "top-start",
                  class: "margin-left5px"
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextSelectMonitorTips), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withId(() => [
                    _createVNode(_component_el_radio, {
                      label: "1",
                      modelValue: _ctx.formData.isSingleMonitor,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.formData.isSingleMonitor = $event)),
                      disabled: _ctx.operaType == 'edit' && _ctx.initShowMonitor
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOn), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"]),
                    _createVNode(_component_el_radio, {
                      label: "0",
                      modelValue: _ctx.formData.isSingleMonitor,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.formData.isSingleMonitor = $event)),
                      disabled: _ctx.operaType == 'edit' && _ctx.initShowMonitor
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOff), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.formData.isSingleMonitor == '1' && _ctx.isShowDevice)
            ? (_openBlock(), _createBlock(_Fragment, { key: 4 }, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$wordList.ProperAllTextIndoorMac,
                  prop: "MAC"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.MAC,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.formData.MAC = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$wordList.TabelPersonDeviceInHtmlLocation,
                  prop: "Location"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.Location,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.formData.Location = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_relay, {
                  relay: _ctx.formData.Relay,
                  commit: _ctx.commit,
                  onGetRelay: _ctx.submit,
                  type: 'local',
                  showUnlock: false
                }, null, 8, ["relay", "commit", "onGetRelay"])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["label-position", "model", "rules"])
    ]),
    _: 1
  }, 8, ["title", "onSubmit"]))
})